module.exports = __webpack_public_path__ + "img/Banner03.d4b623a4.png";